export default __webpack_public_path__ + "static/media/16.019b0ffe.png";